<div class="sla-card">
  <h5 class="sla-card-title">{{ title }}</h5>

  <div class="sla-card-content">
    <div class="sla-table-wrapper" *ngIf="(rules.length || formOpen) && !loading">
      <table class="sla-table" *ngIf="rules.length">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Prioridade</th>
            <th>Atendimento</th>
            <th>Conclusão</th>
            <th class="col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rule of displayedRules; trackBy: trackById">
            <td>{{ serviceTypeLabel(rule.serviceType) }}</td>
            <td>{{ priorityLabel(rule.priority) }}</td>
            <td>{{ rule.responseTimeValue }} {{ timeUnitLabel(rule.responseTimeUnit, rule.responseTimeValue) }}</td>
            <td>
              {{ rule.resolutionTimeValue }} {{ timeUnitLabel(rule.resolutionTimeUnit, rule.resolutionTimeValue) }}
            </td>
            <td class="col-actions">
              <div class="dropdown" dropdown placement="bottom right" container="body">
                <button class="btn-menu" dropdownToggle [disabled]="loading">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                  <li>
                    <button class="dropdown-item" (click)="openEdit(rule)">
                      Editar
                    </button>
                  </li>
                  <li>
                    <button class="dropdown-item text-danger" (click)="openRemoveModal(rule)">
                      Remover
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="sla-table-footer" *ngIf="rules.length > initialDisplayCount">
        <button type="button" class="btn-ver-mais" [class.expanded]="showAll" (click)="toggleShowAll()">
          <i class="fas fa-chevron-down"></i>
          {{ showAll ? 'VER MENOS' : 'VER MAIS' }}
        </button>
      </div>

      <div class="sla-inline-form" *ngIf="formOpen">
        <div class="sla-form-wrapper">
          <div class="sla-form-card">
            <form [formGroup]="form">
              <div class="sla-form-grid">
                <div class="form-group">
                  <label class="form-label required">Tipo de serviço</label>
                  <select
                    class="form-select"
                    formControlName="serviceType"
                    [class.is-invalid]="isInvalid('serviceType')"
                    (change)="onCombinationChange()"
                  >
                    <option value="" disabled>Selecione o tipo</option>
                    <option *ngFor="let type of serviceTypes" [value]="type">
                      {{ serviceTypeLabel(type) }}
                    </option>
                  </select>
                  <span class="select-invalid-feedback" *ngIf="isInvalid('serviceType')">
                    {{ errorMessage('serviceType') }}
                  </span>
                </div>

                <div class="form-group">
                  <label class="form-label required">Prioridade</label>
                  <select
                    class="form-select"
                    formControlName="priority"
                    [class.is-invalid]="isInvalid('priority')"
                    (change)="onCombinationChange()"
                  >
                    <option value="" disabled>Selecione a prioridade</option>
                    <option *ngFor="let priority of priorities" [value]="priority">
                      {{ priorityLabel(priority) }}
                    </option>
                  </select>
                  <span class="select-invalid-feedback" *ngIf="isInvalid('priority')">
                    {{ errorMessage('priority') }}
                  </span>
                </div>

                <div class="form-group">
                  <label class="form-label required">Atendimento</label>
                  <div class="input-group-inline">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Digite o tempo"
                      formControlName="responseTimeValue"
                      [class.is-invalid]="isInvalid('responseTimeValue')"
                      min="1"
                    />
                    <select
                      class="form-select"
                      formControlName="responseTimeUnit"
                      [class.is-invalid]="isInvalid('responseTimeUnit')"
                    >
                      <option value="" disabled>Selecione</option>
                      <option *ngFor="let unit of timeUnits" [value]="unit">
                        {{ timeUnitLabel(unit, 2) | titlecase }}
                      </option>
                    </select>
                  </div>
                  <span class="invalid-feedback" *ngIf="isInvalid('responseTimeValue') || isInvalid('responseTimeUnit')">
                    {{ errorMessage('responseTimeValue') || errorMessage('responseTimeUnit') }}
                  </span>
                </div>

                <div class="form-group">
                  <label class="form-label required">Conclusão</label>
                  <div class="input-group-inline">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Digite o valor"
                      formControlName="resolutionTimeValue"
                      [class.is-invalid]="isInvalid('resolutionTimeValue')"
                      min="1"
                    />
                    <select
                      class="form-select"
                      formControlName="resolutionTimeUnit"
                      [class.is-invalid]="isInvalid('resolutionTimeUnit')"
                    >
                      <option value="" disabled>Selecione</option>
                      <option *ngFor="let unit of timeUnits" [value]="unit">
                        {{ timeUnitLabel(unit, 2) | titlecase }}
                      </option>
                    </select>
                  </div>
                  <span
                    class="invalid-feedback"
                    *ngIf="isInvalid('resolutionTimeValue') || isInvalid('resolutionTimeUnit')"
                  >
                    {{ errorMessage('resolutionTimeValue') || errorMessage('resolutionTimeUnit') }}
                  </span>
                </div>
              </div>

              <div class="alert-duplicate" *ngIf="duplicateError">
                <i class="fas fa-exclamation-circle"></i>
                <span>Já existe uma regra com esta combinação de Tipo de Serviço e Prioridade.</span>
              </div>

              <p class="form-warning">
                <strong>Aviso:</strong> A combinação de Tipo de Serviço e Prioridade deve ser única por contrato.
                Se necessário, edite uma SLA existente ou exclua-a para criar uma nova.
              </p>

              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 20px;"
                (click)="save()"
                [disabled]="loading || duplicateError"
              >
                SALVAR
              </button>
            </form>
          </div>

          <div class="sla-form-side-actions">
            <div class="btn-side-action-wrapper">
              <button
                type="button"
                class="btn-side-action btn-cancel"
                (click)="cancel()"
                [disabled]="loading"
                title="Cancelar"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="btn-side-action-wrapper">
              <button
                type="button"
                class="btn-side-action btn-clear"
                (click)="clearForm()"
                [disabled]="loading"
                title="Limpar formulário"
              >
                <i class="fas fa-eraser"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isDraftMode; else normalNewRule">
      <div class="draft-actions" [class.with-form]="formOpen">
        <p class="draft-info" *ngIf="formOpen">
          Você está criando regras em rascunho. Elas serão vinculadas ao contrato quando ele for salvo.
        </p>

        <button type="button" class="btn-nova-regra" (click)="openCreate()" [disabled]="loading || formOpen">
          <i class="fas fa-plus-circle"></i>
          NOVA REGRA
        </button>
      </div>
    </ng-container>

    <ng-template #normalNewRule>
      <button type="button" class="btn-nova-regra" (click)="openCreate()" [disabled]="loading || formOpen">
        <i class="fas fa-plus-circle"></i>
        NOVA REGRA
      </button>
    </ng-template>

    <div class="sla-loading" *ngIf="loading">
      <div class="spinner"></div>
    </div>
  </div>
</div>

<ng-template #confirmRemoveTpl>
  <div class="modal-header">
    <h5 class="modal-title">Remover Regra</h5>
    <button type="button" class="modal-close" aria-label="Fechar" (click)="closeRemoveModal()" [disabled]="loading">
      &times;
    </button>
  </div>

  <div class="modal-body">
    <p>
      Ao removê-la, os prazos desta regra de SLA não serão mais aplicados às novas Ordens de Serviço. As Ordens já
      concluídas com esta regra permanecerão inalteradas.
    </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-modal-cancel btn-link" (click)="closeRemoveModal()" [disabled]="loading">
      Cancelar
    </button>
    <button type="button" class="btn btn-modal-remove" (click)="confirmRemove()" [disabled]="loading">
      <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
      {{ loading ? 'Removendo...' : 'Remover' }}
    </button>
  </div>
</ng-template>
